module.exports = require('./lib/rendy');
